export default "__VITE_ASSET__55558537__"